import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../Spinner';
import './style.scss';

const Button = ({
    className = '',
    onClick,
    disabled = false,
    img = '',
    submit = false,
    submitting = false,
    text,
}) => (
    <button
        className={`button ${className}`}
        disabled={disabled || submitting}
        onClick={onClick}
        type={submit ? 'submit' : 'button'}
    >
        {
            submitting
                ? <Spinner />
                : (
                    <>
                        {img && <img alt="" src={img} />}
                        {text}
                    </>
                )
        }
    </button>
);

Button.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    img: PropTypes.string,
    onClick: PropTypes.func,
    submit: PropTypes.bool,
    submitting: PropTypes.bool,
    text: PropTypes.string,
};

export default Button;
